const CLOCK_WORKER_CODE = `
self.onmessage = function(e) {
  const view = new Uint32Array(e.data);
  while (true) view[0] = (view[0] + 1) >>> 0;
};
`;

export interface HighResClock {
  read(): number;
  msPerTick: number;
  terminate(): void;
}

export async function createHighResClock(calibrationMs = 100): Promise<HighResClock | null> {
  if (typeof SharedArrayBuffer === 'undefined') return null;

  let sab: SharedArrayBuffer;
  try { sab = new SharedArrayBuffer(1024); } catch { return null; }

  const view = new Uint32Array(sab);
  const blob = new Blob([CLOCK_WORKER_CODE], { type: 'application/javascript' });
  const url = URL.createObjectURL(blob);
  const worker = new Worker(url);
  worker.postMessage(sab, [sab]);

  await new Promise((resolve) => setTimeout(resolve, 10));

  const t0 = performance.now();
  const c0 = view[0];
  const target = t0 + calibrationMs;
  while (performance.now() < target) { /* busy-wait for calibration */ }
  const t1 = performance.now();
  const ticks = (view[0] - c0) >>> 0;
  const msPerTick = ticks > 0 ? (t1 - t0) / ticks : 0;

  return {
    read: () => view[0],
    msPerTick,
    terminate: () => { worker.terminate(); URL.revokeObjectURL(url); },
  };
}

export function measureWithClock(
  clock: HighResClock,
  fn: () => void,
  runs: number,
  warmup: number
): number[] {
  for (let i = 0; i < warmup; i++) fn();
  const samples: number[] = [];
  for (let i = 0; i < runs; i++) {
    const t0 = clock.read();
    fn();
    const t1 = clock.read();
    samples.push(((t1 - t0) >>> 0) * clock.msPerTick);
  }
  return samples;
}
